const useModuleNavigation = ({ module }) => {
    const chapters = computed(() => module.value?.chapters || []);

    const params = useRoute().params;

    const chapterIndex = computed(() => {
        if (!module || !params.chapter) {
            return 0;
        }

        return chapters.value.findIndex((chapter) =>
            chapter.slug === params.chapter
        );
    });

    const sections = computed(() => {
        const chapter = chapters.value[chapterIndex.value];
        return chapter?.sections || [];
    });

    const nextItem = computed(() => {
        // Start
        if(!chapterIndex) {
            return toValue(module)?.chapters?.[0];
        }

        // Start first item within chapter
        if(!params.item) {
            // First section
            return sections.value[0];
        }

        // Check within chapter
        const sectionIndex = sections.value.findIndex((item) => item.slug === params.item);

        // Has next section
        if (sectionIndex >= 0 && sectionIndex < sections.value.length - 1) {
            return sections.value[sectionIndex + 1];
        }

        // Start new chapter
        return chapters.value[chapterIndex.value + 1];
    });

    const previousItem = computed(() => {
        // Start
        if(!chapterIndex) {
            return null;
        }

        // Start first item within chapter
        if(!params.item) {
            return null;
        }

        // Check within chapter
        const sectionIndex = sections.value.findIndex((item) => item.slug === params.item);

        // Has previous section
        if (sectionIndex > 0) {
            return sections.value[sectionIndex - 1];
        }

        // Start new chapter
        return chapters.value[chapterIndex.value];
    });

    const nextChapter = computed(() => {
        if (!chapterIndex) {
            return chapters.value[0];
        }

        if (chapterIndex.value < chapters.value.length - 1) {
            return chapters.value[chapterIndex.value + 1];
        }

        return null;
    });

    const items = computed(() =>
        sections.value.map((item) => ({
            ...item,
            active: item.slug === params.item,
        }))
    );

    return {
        chapters,
        chapterIndex,
        sections,
        nextItem,
        previousItem,
        nextChapter,
        items,
    };
};

export default useModuleNavigation;
